"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PowerQualityIssueValidation = void 0;
class PowerQualityIssueValidation {
    static isValid(enumValue) {
        if (typeof enumValue !== "number")
            return false;
        if (!(0 <= enumValue && enumValue <= 14)) {
            return false;
        }
        return true;
    }
}
exports.PowerQualityIssueValidation = PowerQualityIssueValidation;
